module.exports = __webpack_public_path__ + "static/Casablanca2-3acd2d6892a48b5d682d3c865ab7fb46.jpg";